import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { FeatureFlag } from '../constants/feature-flag.enum';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagUtil {
    isFeatureEnabled(feature: FeatureFlag): boolean {
        return environment.features?.includes(feature) ?? false;
    }
}
